import { useEffect, useState } from 'react';
import { IoCheckmarkCircle } from 'react-icons/io5';
import ReactModal from 'react-modal';
import { map, skipWhile, take } from 'rxjs/operators';

import { Order } from '../../store/order';
import { formatDate } from '../../utils/dayjs';
import CUSTOM_STYLES from '../../utils/modalStyle';
import { PrimaryButton } from '../Buttons/Buttons';
import MainLogo from '../MainLogo/MainLogo';

import styles from './OrderAlertSuccess.module.scss';

const modalLabel = 'order success message';

export default function OrderAlertSuccess({ isModalOpen, onClickOk, isForGuestUser }) {
  const [order, setOrder] = useState();
  useEffect(() => {
    const orderServerResponse$ = Order.subject
      .pipe(
        skipWhile(v => !v?.serverResponse),
        map(v => v?.serverResponse),
        take(1)
      )
      .subscribe(setOrder);

    Order.reset();

    return () => {
      orderServerResponse$.unsubscribe();
    };
  }, []);

  if (!order) return null;

  const finalPriceString = `${order.totalPrice
    .toString()
    .substring(0, order.totalPrice.toString().length - 2)}.${order.totalPrice.toString().substr(-2)} €`;

  return (
    <ReactModal isOpen={isModalOpen} style={CUSTOM_STYLES} contentLabel={modalLabel} ariaHideApp={false}>
      <section className={styles.modalContainer}>
        <div className={styles.logo}>
          <MainLogo />
        </div>
        <div className={styles.textContainer}>
          <IoCheckmarkCircle className={styles.checkMark} />

          <div>
            <p className={styles.text}>Η παραγγελία σου ήταν επιτυχής!</p>
            <p className={styles.detailsText}>Η παραγγελία σου καταχωρήθηκε με επιτυχία.</p>
            <p className={styles.detailsText}>
              Έχει αποσταλεί αντίτυπο του αποδεικτικού συναλλαγής και παραγγελίας στο email σου.
            </p>
          </div>
        </div>
        {!isForGuestUser && (
          <div className={styles.orderInfoContainer}>
            <p className={styles.orderText}>Όνομα πελάτη</p>
            <p className={styles.orderInfo}>{order.user.fullName}</p>
          </div>
        )}
        {order.orderNumber && (
          <div className={styles.orderInfoContainer}>
            <p className={styles.orderText}>Κωδικός παραγγελίας</p>
            <p className={styles.orderInfo}>{order.orderNumber}</p>
          </div>
        )}
        <div className={styles.orderInfoContainer}>
          <p className={styles.orderText}>Ποσό πληρωμής</p>
          <p className={styles.orderInfo}>{finalPriceString}</p>
        </div>
        {order.paymentAuthCode && (
          <div className={styles.orderInfoContainer}>
            <p className={styles.orderText}>Αριθμός συναλλαγής</p>
            <p className={styles.orderInfo}>{order.paymentAuthCode}</p>
          </div>
        )}
        <div className={styles.orderInfoContainer}>
          <p className={styles.orderText}>Ημερομηνία και ώρα</p>
          <p className={styles.orderInfo}>{formatDate(order.createdAt, 'DD/MM/YYYY HH:mm')}</p>
        </div>

        <div className={styles.btnContainer} data-cy="success-order-modal-btn">
          <PrimaryButton data-cy="order-success-ok" onClick={onClickOk}>
            Εντάξει
          </PrimaryButton>
        </div>
      </section>
    </ReactModal>
  );
}
